<script setup lang="ts">
    import TaskCollection from '@/app/task/collections/TaskCollection';

    withDefaults(
        defineProps<{
            collection: TaskCollection;
            displayIcons?: boolean;
        }>(),
        {
            displayIcons: true,
        }
    );
</script>

<template>
    <table class="w-full">
        <tbody>
            <TaskTaskLineTr
                v-for="task in collection.get()"
                :key="task.getInternalId()"
                @contextmenu="task.openContextMenu($event)"
                :task="task"
                :display-icons="displayIcons"
            />
        </tbody>
    </table>
</template>
